import React, { useCallback } from 'react'
import YouTubePlayer from 'youtube-player'

export interface YTPlayerProps {
  videoId: string
  onReady?: (target: any) => void
  onStateChange?: (data: any) => void
  onPlaybackQualityChange?: (data: any) => void
  onError?: () => void
  isVerticalVideo?: boolean
}

//TODO: proper typing for each memoized function
const YTPlayer = ({
  videoId,
  onReady = null,
  onStateChange = null,
  onPlaybackQualityChange = null,
  onError = null,
  isVerticalVideo = false,
}) => {
  const playerRef = React.useRef(null)
  let ytPlayer = React.useRef(null)

  const onReadyCallback = useCallback(
    (target) => {
      onReady?.(target)
    },
    [onReady]
  )

  const onStateChangeCallback = useCallback(
    (data) => {
      onStateChange?.(data)
    },
    [onStateChange]
  )

  const onPlaybackQualityChangeCallback = useCallback(
    (data) => {
      onPlaybackQualityChange?.(data)
    },
    [onPlaybackQualityChange]
  )

  const onErrorCallback = useCallback(
    (event) => {
      onError?.(event)
    },
    [onError]
  )

  React.useEffect(() => {
    ytPlayer.current = YouTubePlayer(playerRef.current, {
      playerVars: {
        modestbranding: 1,
      },
    })
    ytPlayer.current.cueVideoById(videoId)
    ytPlayer.current.on('ready', onReadyCallback)
    ytPlayer.current.on('stateChange', onStateChangeCallback)
    ytPlayer.current.on(
      'playbackQualityChange',
      onPlaybackQualityChangeCallback
    )
    ytPlayer.current.on('error', onErrorCallback)

    return () => {
      ytPlayer.current.destroy()
    }
  }, [
    onErrorCallback,
    onPlaybackQualityChangeCallback,
    onReadyCallback,
    onStateChangeCallback,
    playerRef,
    videoId,
  ])

  return (
    <div
      className="yt-ratio-wrapper bg-red-40"
      style={{
        aspectRatio: isVerticalVideo ? '9/16' : '16/9',
      }}
    >
      <div ref={playerRef} className="w-full bg-gray-5" />
    </div>
  )
}

export default YTPlayer
